export function cLog(data) {
  console.log(data);
}
